var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"requested-document-processor-root"},[(!!_vm.requestedUrl)?_c('iframe',{attrs:{"src":_vm.requestedUrl,"width":"100%","height":"100%"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }